<template>
  <div class="hello">
    <h1>Googleマップの位置座標を整形くん(α版)</h1>
    説明: GoogleマップのURLを貼ると、フラグフォーマットに整形し、<br />コピー可能な状態にするツールです。
  </div>

  <br />

  <div class="hello2">
    Google MapsのURL
    <input v-model="message" placeholder="edit me" />
  </div>

  <div class="hello3">
    フラグフォーマット<input v-model="format" placeholder="regex" />
  </div>

  <div class="hello5">小数点何位へ丸めるか<input v-model="keta" /></div>

  <div class="hello6">
    <p>整形後の文字列: {{ current_predict }}</p>
  </div>

  <div class="hello4">
    <input
      v-on:focus="$event.target.select()"
      ref="myinput"
      readonly
      :value="current_predict"
    />
    <button @click="copy">文字列をコピー</button>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data: () => ({
    message:
      "https://www.google.co.jp/maps/search/%E3%82%B9%E3%82%AB%E3%82%A4%E3%83%84%E3%83%AA%E3%83%BC/@35.7101593,139.8085556,17z/data=!3m1!4b1?hl=ja&authuser=0",
    my_regex: "-?[0-9.]+,-?[0-9.]+",
    keta: 3,
    format: "N${IDO} E${KEIDO}",
  }),
  computed: {
    current_predict: function () {
      // const re = /\d+/;
      var re = new RegExp(this.my_regex);
      // const bar = this.message.match(self.my_regex);
      var bar = this.message.match(re);
      // return this.message.replace(/_/g, "-") + ".";
      bar = bar[0].split(",");
      var ido = Number(parseFloat(bar[0]));
      ido = ido.toFixed(this.keta).toString();
      var keido = Number(parseFloat(bar[1]));
      keido = keido.toFixed(this.keta).toString();

      return this.format.replace("${IDO}", ido).replace("${KEIDO}", keido);
    },
  },
  methods: {
    copy() {
      this.$refs.myinput.focus();
      document.execCommand("copy");
    },
  },
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
